/**
 * UltraLife Trades — Shared Color Palette
 *
 * Single source of truth for all brand colors.
 * Import from here instead of defining local constants.
 */

const COLORS = {
  bark: "#2C1810",
  cedar: "#8B5E3C",
  honey: "#C4913B",
  pine: "#4A7C59",
  snow: "#F5F0EB",
  stone: "#9B8E82",
  slate: "#3D3D3D",
  cream: "#FDF8F3",
  white: "#FFFFFF",
  accent: "#C4913B",
  red: "#C44B3B",
  green: "#4A7C59",
  blue: "#3B7CC4",
  glassBg: "rgba(255,255,255,0.97)",
};

export default COLORS;
